import { render } from "./TeacherSync.vue?vue&type=template&id=7978e5c4&scoped=true&ts=true"
import script from "./TeacherSync.vue?vue&type=script&lang=ts"
export * from "./TeacherSync.vue?vue&type=script&lang=ts"

import "./TeacherSync.vue?vue&type=style&index=0&id=7978e5c4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7978e5c4"]])

export default __exports__